import { createAction, props } from '@ngrx/store';
import { PaginationWithFiltersRequest } from '../../../../api/models/pagination-with-filters-request';
import { SupplierListV1 } from '../../../../api/models/supplier-list-v-1';

export enum SupplierListActionTypes {
  READ_ALL = '[SUPPLIER_LIST] READ_ALL',
  READ_ALL_SUCCESS = '[SUPPLIER_LIST] READ_ALL_SUCCESS',
  READ_ALL_FAILED = '[SUPPLIER_LIST] READ_ALL_FAILED',

  RESET = '[SUPPLIER_LIST] RESET',
}

export const loadSupplierList = createAction(
  SupplierListActionTypes.READ_ALL,
  props<{ pagination: PaginationWithFiltersRequest }>()
);

export const readAllSupplierListSuccess = createAction(
  SupplierListActionTypes.READ_ALL_SUCCESS,
  props<{
    suppliers: SupplierListV1[];
    totalElements: number;
  }>()
);

export const readAllSupplierListFailed = createAction(
  SupplierListActionTypes.READ_ALL_FAILED,
  props<{ error?: unknown }>()
);

export const resetSupplierList = createAction(SupplierListActionTypes.RESET);
